
    window.graft = window.graft ? window.graft : {}

    window.graft.isModianIos = () => {
        return /ios-modian/.test(navigator.userAgent.toLowerCase())
    }
    window.graft.isModianAndroid = () => {
        return /android-modian/.test(navigator.userAgent.toLowerCase())
    }
    window.graft.client_code = 0
    if (window.graft.isModianIos()) {
        window.graft.client_code = 1
    }
    if (window.graft.isModianAndroid()) {
        window.graft.client_code = 2
    }
    window.graft.app = ({ functionName, functionParams, webFun, callBack, showAlert = false }) => {
        if (callBack && typeof callBack == "function") {
            if (functionName == 'playAudio') {
                window.graft[functionName] = callBack
            } else {
                graft[functionName] = callBack
            }
        }
        if (showAlert) {
            window.graft.showAlert = showAlert
        }
        graft.onSendToNativeRequest({ functionName, functionParams, webFun })
    }
    window.graft.onSendToNativeRequest = ({ functionName, functionParams, webFun }) => {
        let postMessage = {
            functionName: functionName,
            functionParams: functionParams,
        }
        if ([1, 2].includes(window.graft.client_code)) {
            window.graft.client_code === 1
                ? window.webkit.messageHandlers.onSendToNativeRequest.postMessage(postMessage)
                : window.appInterface.onSendToNativeRequest(JSON.stringify(postMessage))
        } else {
            if (webFun && typeof webFun == "function") {
                webFun()
            }
        }
    }
    window.onCallBackToJsResponse = (functionName, data) => {
        // if (window.graft.showAlert) {
        //     alert(functionName + data)
        // }
        if (window.graft[functionName] && typeof window.graft[functionName] == "function") {
            window.graft.client_code === 1 ? window.graft[functionName](data) : window.graft[functionName](JSON.parse(data))
        }
    }
    const shareInfo = {
        id: 1,
        title: "快来和我一起玩吧!",
        img: "",
        wx_title: `快来和我一起玩吧!''`,
        wx_des: `'https://www.modian.com/'`,
        weixin_share_url: "https://www.modian.com/",
        wxTimeline_title: `快来和我一起玩吧!''`,
        wxTimeline_des: `'https://www.modian.com/'`,
        wxTimeline_share_url: "https://www.modian.com/",
        qq_title: `快来和我一起玩吧!`,
        qq_des: `'https://www.modian.com/'`,
        qq_share_url: "https://www.modian.com/",
        qzone_title: `快来和我一起玩吧!`,
        qzone_des: `'https://www.modian.com/'`,
        qzone_share_url: "https://www.modian.com/",
        weibo_title: "https://www.modian.com/",
        weibo_des: `快来和我一起玩吧!''`,
        weibo_share_url: "https://www.modian.com/",
        msg_des: `快来和我一起玩吧!''`,
        sharelink_url: "https://www.modian.com/",
    }
    const appMap = [
        {
            functionName: "onGetUserInfo",
            functionData: null,
            prompt: "获取用户信息",
        },
        {
            functionName: "onGetPushState",
            functionData: null,
            prompt: "获取推送权限状态 1打开 0关闭",
        },
        {
            functionName: "webShareEnabled",
            functionData: { shareEnabled: 1, shareInfo },
            prompt: "该Web页是否可分享<1可分享 0不可>",
        },
        {
            functionName: "isWXAppInstalled",
            functionData: null,
            prompt: "检测微信是否安装<1是 0否>",
        },
        {
            functionName: "isWeiboAppInstalled",
            functionData: null,
            prompt: "检测微博是否安装<1是 0否>",
        },
        {
            functionName: "isQQInstalled",
            functionData: null,
            prompt: "检测QQ是否安装 <1是 0否>",
        },
        {
            functionName: "openShareTool",
            functionData: shareInfo,
            prompt: "打开Native分享组件",
        },
        {
            functionName: "shareToWeChat",
            functionData: shareInfo,
            prompt: "分享至微信好友",
        },
        {
            functionName: "shareToWeChatTimeLine",
            functionData: shareInfo,
            prompt: "分享至微信朋友圈",
        },
        {
            functionName: "shareToSina",
            functionData: shareInfo,
            prompt: "分享至新浪微博",
        },
        {
            functionName: "shareToQQ",
            functionData: shareInfo,
            prompt: "分享至QQ好友",
        },
        {
            functionName: "shareToQzone",
            functionData: shareInfo,
            prompt: "分享至QQ空间",
        },
        {
            functionName: "onImageClicked",
            functionData: {
                imageUrls: [
                    "https://testupload.modianinc.com/path/dst_kuji/202104/0212/1617/4jrnKmB2kYNJENY3bvXpM5GQ9q6RdA.png",
                    "https://testupload.modianinc.com/path/dst_kuji/202103/3009/5747/Y13ADGjKOZgVy65xMEx4pe5an8lRQw.jpg",
                ],
                imageIndex: 1,
            },
            prompt: "点击查看大图 <参数为H5页面内图片链接数组>",
        },
        {
            functionName: "webNavColor",
            functionData: { alpha: 0.5, bgColor: "#cabe14", titleColor: "#156bba" },
            prompt: "修改沉浸式web顶部视图<导航栏/标题/返回按钮",
        },
        {
            functionName: "openController",
            functionData: "https://www.modian.com/",
            prompt: "打开新的页面,参数为md://内链或H5链接",
        },
        {
            functionName: "closeController",
            functionData: "",
            prompt: "关闭当前的web页面控制器",
        },
        {
            functionName: "login",
            functionData: "",
            prompt: "登录",
        },
        {
            functionName: "preparyPlayMedia",
            functionData: "",
            prompt: "H5内嵌视频/音频播放时中止Native当前播放",
        },
    ]

    window.graft.help = () => {
        document.body.innerHTML = ""
        appMap.map((e, idx) => {
            let div = document.createElement("div")
            div.innerHTML = e.prompt + '--' + e.functionName
            div.style.cssText = "border:1px solid"
            div.onclick = function () {
                console.log(e.functionName, e.functionData)
                window.graft.app({ functionName: e.functionName, functionParams: e.functionData, showAlert: true })
            }
            document.body.appendChild(div)
        })

        let div = document.createElement("div")
        div.id = 'tip'
        document.body.appendChild(div)
        div = `<div style='margin-top:20px'>示例:</div><div style='border:1px solid'>graft.app({ functionName:'onGetUserInfo',functionParams: [],<br/> callBack:(e)=>{
        alert(e.data.build)
    },<br/> webFun:()=>{
        console.log(this.client_code)
    }<br/> ,showAlert:false })</div><div style='border:1px solid'> 调用摩点app原生方法: <br/>graft.app({functionName,functionParams,callBack,webFun,showAlert})</div>
    <div>functionName : (String)调用的方法名↑</div><div>functionParams : 传递参数(String,Array,Object)</div><div>callBack : (Function)回调方法</div>
    <div>webFun :(Function)不在app环境中触发方法</div><div>showAlert : (true,false)显示app传回参数</div>`
        document.querySelectorAll('#tip')[0].innerHTML = div
    }

